import { useNavigate } from 'react-router-dom';
import NftPreview from '../../components/nft/NftPreview';
import { useGlobalState } from '../../state/GlobalStateProvider';
import arrowImg from '../Idn_arrow.svg';

import './IdentityCard.scss';

const IdentityCard = ({ title, event, nftProfile, campaign, img }) => {
  const [{ user }] = useGlobalState();
  const navigate = useNavigate();
  return (
    <>
      <div className='identity_card'>
        <div className='identity_text'>{title}</div>
        <div class='nft_preview_border'>
          {user && nftProfile ? (
            img ? (
              <></>
            ) : (
              <div className='nft_level'>
                <div className='text'>Level {nftProfile?.properties?.Level?.details?.level || 0}</div>
                <div className='level_name'>{nftProfile?.properties?.Level?.details?.name || ''}</div>
              </div>
            )
          ) :(
            <></>
          )}

          {img ? (
            <img src={img} alt='img' className='blur_img' />
          ) : (
            <>
              <div className='nft-preview'>
                <div className='border_active'></div>
                <NftPreview className='xion_preview' src={nftProfile?.animation_url} template={campaign?.template} />
              </div>
            </>
          )}
        </div>
        {img ? (
          <div className='blur_explore'>COMING SOON</div>
        ) : (
          <div
            className='explore_btn'
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/identity');
            }}
          >
            EXPLORE IDENTITY{' '}
            <span className='arrow'>
              <img src={arrowImg} alt='arrow' />
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default IdentityCard;
